<template>
  <div class="ic-form__connection">
    <h3>{{label}}</h3>
   

<div class="panel" v-if="selected">
<p>Wybrano połączenie: <br/>
<b>{{ value.departureStationName }}</b> -> <b>{{ value.arrivalStationName }}</b>, {{ value.departureDate }} {{ value.departureTime }}, {{ value.trainNo }}
</p>
</div>
 
<IcFormRowWrapper
          rowElement="IcFormRow"
          id="isSelected"
          :name="name+'.isSelected'"
          :aria="$t('aria_required')"
          label=""
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <div>
              <button type="button" class="btn btn-primary" data-bs-toggle="modal" :data-bs-target="'#'+name+'selectConnectionModal'" >
              {{value.isSelected?$t('label_zmien_polaczenie'):$t('label_wybierz_polaczenie')}}
              </button>
              <!-- <p :class="{'error': this.$v.form.connection.$anyError}">
                wybierz połączenie
              </p> -->
              {{ v }}
            </div>
          </template>
        </IcFormRowWrapper>




<div class="modal fade" :id="name+'selectConnectionModal'" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered modal-lg" :class="hasResults">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Wyszukaj połączenie</h5>
        <button type="button" ref="Close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>      
      <div class="modal-body">

        <div class="row" >
      <div class="col-md-6">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="departureStation"
          :name="name+'.departureStation'"
          :aria="$t('aria_required')"
          :label="$t('label_departureStation')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcStationTypeahead
              id="departureStation"
              v-model="data.departureStation"
              valueField="h"
              :noMeta="1"
              :icStation="-1"
              @input="emitInput(data,validator)"
              :disabled="inProgress"
            ></IcStationTypeahead>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-6">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="arrivalStation"
          :name="name+'.arrivalStation'"
          :aria="$t('aria_required')"
          :label="$t('label_arrivalStation')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcStationTypeahead
              id="arrivalStation"
              v-model="data.arrivalStation"
              valueField="h"
              :noMeta="1"
              :icStation="-1"
              @input="emitInput(data,validator)"
              :disabled="inProgress"
            ></IcStationTypeahead>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>        
    <div class="row">
      <div class="col-md-4">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="departureDate"
          :name="name+'.departureDate'"
          :aria="$t('aria_required_date')"
          :label="$t('label_departureDate')"
          :labelWidth="4"
          :controlWidth="8"
          :disabled="inProgress"
        >
          <template slot-scope="{validator}">
            <ic-date-picker
              id="departureDate"
              v-model="data.departureDate"
              @input="emitInput(data,validator)"
              :minDate="minDate"
              :endDate="endDate"
              title=""
              :disabled="inProgress"
              aria="Strzałka w górę dół, następny poprzedni dzień."
            ></ic-date-picker>
          </template>
        </IcFormRowWrapper>
         </div>
      <div class="col-md-2 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="departureTime"
          :name="name+'.departureTime'"
          :aria="$t('aria_required_time')"
          :label="$t('label_departureTime')"
          :labelWidth="4"
          :controlWidth="8"

        >
          <template slot-scope="{validator}">
            <IcTimePicker
              id="departureTime"
              v-model="data.departureTime"
              @input="emitInput(data,validator)"
              :disabled="inProgress"
            ></IcTimePicker>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-6 text-right">
        <button class="btn btn-primary mt-4" @click.prevent="searchConnection" :disabled="(inProgress || !data.arrivalStation || !data.departureStation || !data.departureDate || !data.departureTime)">{{inProgress?$t('label_czekaj'):$t('label_szukaj')}}</button>
      </div>
    </div>
      <div id="connections" class="mt-5" v-if="hasResults">
  
  <div class="itinerary itinerary-promo mb-3" v-for="item in connections"  :key="item.id">
    <div class="itinerarySummary">
      <div class="itinerarySummary__destinations">
        <div class="row gy-5">
          <div class="col-12 col-xl-10 d-flex align-items-center  justify-content-start ps-5">
            <div class="itinerarySummary__destination itinerarySummary__destination--start">
              <div>
                <div class="city">{{ item.departure.name }}</div>
                <div class="time">
                 {{moment.utc(item.departure.date*1000).format("HH:mm")}}                <small>{{moment.utc(item.departure.date*1000).format("YYYY-MM-DD")}}</small>
                </div>
              </div>
            </div>
            <div class="itinerarySummary__number">
              {{ moment.utc(item.duration*1000).format("HH:mm") }}
              <hr>
              <small>{{item.sections[0].train.name}}</small>
            </div>
            <div class="itinerarySummary__destination itinerarySummary__destination--end">
              <div>
                <div class="city">
                  {{ item.arrival.name }}              </div>
                <div class="time">
                  {{moment.utc(item.arrival.date*1000).format("HH:mm")}}                <small>{{moment.utc(item.arrival.date*1000).format("YYYY-MM-DD")}}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-2 d-flex align-items-center justify-content-xl-end justify-content-center">
                        <div class="itinerarySummary__button-std order-1 order-xl-3 mx-2">
                          <button class="btn btn-warning" @click="selectConnection(item)">{{$t('wybierz')}}</button>
                        </div>
          </div>
        </div>
      </div>


    </div>

  </div>
      </div>
      <div class="alert alert-danger mt-4 " v-if="searchErrors.length">
      <span v-for="error in searchErrors" :key="error.id">
        {{  error }}
      </span>
      </div>
      </div>
    </div>
  </div>
</div>

  </div>
</template>

<script>
import IcInput from "@/components/ic-common/form/controls/Input";
import IcInputZip from "@/components/ic-common/form/controls/InputZip";
import IcStationTypeahead from "@/components/ic-common/form/controls/StationTypeAhead";
import IcDatePicker from "@/components/ic-common/form/controls/DatePicker";
import IcTimePicker from "@/components/ic-common/form/controls/TimePicker";
import IcSelect from "@/components/ic-common/form/controls/Select";
import { Connection } from "@/components/ic/form/contact/Model/Connection";
import { emitInput } from "./mixins";
import moment from "moment";
import { debounce } from 'lodash';

export default {
  name: "IcFormSelectConnection",
  props: {
    error: {
      type: [String, Object, Boolean],
      required: false
    },    
    v:{
      
    },
    label: {
      type: String,
      default: "Połączenie"
    },    
    name: {
      type: String,
      default: "connection"
    },    
    value: {
      type: [Object,Array],
      default: new Connection()
    },

    minDate: {
      type: String,
      default: moment().format("YYYY-MM-DD")
    },
    endDate: {
      type: String,
      default: moment()
        .add(1, "years")
        .format("YYYY-MM-DD")
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.data = this.value;
    }
  },
  data() {
    return {
      data: Object.assign({}, new Connection(), this.value),
      url:"/ax26hrxl857-a/components/icsearch/connector.php?action=search&cultureKey=pl", //"/connection/search-ajax",
      connections: "",
      hasResults: false,
      searchErrors: [],
      inProgress:false,
      selected:false,
    };
  },
  methods: {
    cv: function(){
    },
    emitInput,
    selectConnection: function(i){
      this.selected = true;
      this.value.isSelected = true;
      this.value.departureStationName = i.departure.name;
      this.value.arrivalStationName = i.arrival.name;
      this.value.trainNo = i.sections[0].train.name;
      this.value.departureDate = moment.utc(i.departure.date*1000).format("YYYY-MM-DD");
      this.value.departureTime = moment.utc(i.departure.date*1000).format("HH:mm");
      this.$refs.Close.click();
    },
    searchConnection: debounce(function () {
      this.inProgress = true;
      if (this.data.arrivalStation) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.data)
        };        
        fetch(this.url,requestOptions)
          .then(response => {
            return response.json();
          })
          .then(data => {
            if(data && data.length && data[0].connections.length){
              this.connections = data[0].connections;
              this.hasResults = true;
              this.searchErrors = [];
            }
            else {
              if(data && data.length)
                this.searchErrors = data[0].errors;
              else
                if(data.errors)
                  this.searchErrors = Object.values(data.errors);

              this.hasResults = false;
              this.connections = [];
            }

            this.inProgress = false;
          }).catch(e => {
            //console.log(e);
            this.searchErrors = [];
            this.searchErrors.push("Nie znaleziono połączeń w danym dniu o podanej godzinie.");
            this.inProgress = false;
          })
      }
    }, 150),    
  },
  components: {
    IcInput,
    IcInputZip,
    IcStationTypeahead,
    IcDatePicker,
    IcTimePicker,
    IcSelect
  }
};
</script>

<style>
</style>
